import {
  Box,
  CircularProgress,
  InputAdornment,
  TextField,
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'

import { FieldInfo } from '@/pages/maps/contexts/region-context'

import { useStyles } from './styles'

interface SearchBarFieldsProps {
  regionFieldsInfo: (FieldInfo & { checked: boolean })[]
  search: { searchTerm: string; setSearchTerm: (searchTerm: string) => void }
  isLoading?: boolean
}

export default function SearchBarFields({
  regionFieldsInfo,
  isLoading,
  search,
}: SearchBarFieldsProps) {
  const classes = useStyles()

  const isDisabled = isLoading || !regionFieldsInfo.length
  const { searchTerm, setSearchTerm } = search

  return (
    <Box
      className={classes.searchContainer}
      style={{ opacity: isDisabled ? 0.5 : 1 }}
    >
      <TextField
        size='small'
        placeholder='Busque o talhão'
        variant='outlined'
        fullWidth
        disabled={isDisabled}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={classes.searchField}
        InputProps={{
          endAdornment: isLoading ? (
            <CircularProgress size={24} />
          ) : (
            <InputAdornment position='end'>
              <SearchIcon
                className={classes.searchIcon}
                aria-label='ícone de busca'
              />
            </InputAdornment>
          ),
        }}
        inputProps={{ 'aria-label': 'Busque o talhão' }}
      />
    </Box>
  )
}
